
import { Course } from '../types';

export const child_maintenance: Course = {
  id: "child_maintenance",
  title: "Child Maintenance (CMS)",
  description: "Understand the financial obligations and how they are calculated.",
  icon: "💷",
  totalModules: 14,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    13: { id: 13, title: "Slide 13", slides: [{ title: "Slide 13", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide13.PNG" alt="Slide 13" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    14: { id: 14, title: "Slide 14", slides: [{ title: "Slide 14", content: `<div class="flex justify-center"><img src="/images/courses/child_maintenance/Slide14.PNG" alt="Slide 14" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "According to UK Child Maintenance Service regulations, what percentage of the paying parent's gross weekly income is initially calculated for maintenance for two children?",
        "o": [
            "12%",
            "16%",
            "19%",
            "20%"
        ],
        "a": 1
    },
    {
        "q": "The Family Court has limited power in UK child maintenance cases. Under what specific condition can they intervene to make 'Top-Up' orders?",
        "o": [
            "When the paying parent's gross income is less than £50,000 per year.",
            "When the paying parent's gross income exceeds £156,000 per year.",
            "If the Child Maintenance Service is unable to make a determination.",
            "In all cases involving more than three children."
        ],
        "a": 1
    },
    {
        "q": "What specific annual number of overnight stays with children triggers a precise 2/7th reduction of the child maintenance liability?",
        "o": [
            "52+ Nights (averaging at least one night a week)",
            "104+ Nights",
            "175+ Nights (considered 50/50 care)",
            "Any number of nights, as long as it's consistent"
        ],
        "a": 1
    },
    {
        "q": "Regarding variations to child maintenance, what is the minimum weekly travel expense threshold that allows a paying parent to apply for an offset against their gross income calculation?",
        "o": [
            "£5 per week",
            "£10 per week",
            "£15 per week",
            "£20 per week"
        ],
        "a": 1
    },
    {
        "q": "Which method of executing child maintenance payments introduces financial penalties, including a 20% surcharge for the payer and a 4% deduction for the payee?",
        "o": [
            "Direct Pay",
            "Collect & Pay",
            "Voluntary arrangement",
            "Court-mandated transfer"
        ],
        "a": 1
    }
]
};
